import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FEAT_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { baseMenuItems, featureGroupsMenuItems, featureMenuItems, featureOptions, featureTypeMenuItems } from './configoptions';
import { Observable, catchError, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { feature_type_baseMenuItems } from './feature-types/configoptions';

@Component({
  selector: 'ubs-features',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent  extends BaseComponentConfig implements OnInit {
  /* options:ConfigOptions = {
    name:"",
    title:"Feature Componment",
    listForm: new OfbizList({
      listType:"grid",
      listFormName:"ListProductFeature",
      listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
      columnFields:this.getFields("ListProductFeature",FEAT_FORMS),
      columnFieldTitles:this.getColumnFieldTitles("ListProductFeature",FEAT_FORMS),
      appContext:"catalog",
      emptyListMessage:"No feature categories currently on system",
      remoteFormData:{
        formData:{
          formName:"ListProductFeature",
          formLocation:"component://kwikstore/widget/FeatureForms.xml",
          listType:"grid"
        }
      }
    }),
    addForm: new OfbizForm({}),
    findForm:new OfbizForm({}),
    settings:[],
    actions:[],
    breadCrumbData:{
      displayPrefix:"Product Feature Categories",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductFeature",
        "data":{
          formData:{
            formName:"ListProductFeature",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"grid"
          },
          "endPoint":"",
          "parameters":{"prodCatalogId":""}
        }
      },
      addFormText:"Create Feature Category",
      editFormText:"Update Feature Category"
    },
    
    
  } */

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(featureOptions);
   }

  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuItems:NbMenuItem[] = [];
    baseMenuItems.forEach(item => {
      menuItems.push(item);
    })
    menuItems.push({title:"Recent Product Feature Category",group:true,icon:"grid-outline"})
    let menuTag = menuAndTitleOptions.menuTag;
    console.log(menuTag);
    this.getProductFeatureCats(this.baseUrl).subscribe(resp => {
      let productFeatureCategories:any[] = [];
      let message = resp["successMessage"]
      if(message == "OK"){
        let data = resp["data"];
          let formData = data["formData"];
          let rows:any[] = formData.rows;
          console.log(rows);
          rows.forEach((row:any[]) => {
            let productFeatureCategory:any = {};
            row.forEach(field => {
              for(let[k,v] of Object.entries(field)){
                if(k === "productId"){
                  v = field["parameterMap"]["productId"]
                }
                productFeatureCategory[k] = v;
              }
            })
            productFeatureCategories.push(productFeatureCategory);
          })
          if(productFeatureCategories.length > 0){
            let _menuItems = this.createMenuItems(productFeatureCategories);
            console.log(_menuItems);
            menuItems = menuItems.concat(_menuItems);
          }
          this.menuService.addItems(menuItems,menuTag);
          this.addChildMenus(menuTag);
      }
      console.log(menuItems);
      //this.menuService.addItems(menuItems,menuTag)
      //this.componentConfig.menuAndTitleOptions.menuItems = menuItems;
      //this.menuService.addItems(feature_type_baseMenuItems,menuTag)
    })
    //this.menuService.addItems(feature_type_baseMenuItems,menuTag)
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    /* setTimeout(() => {
      this.componentConfig.menuAndTitleOptions.menuItems = menuItems;
    }, 1000); */
    
  }

  getProductFeatureCats(baseUrl:string):Observable<any>{
    let url:string = baseUrl+'widgets/grid/value/ListProductFeatureCategories?location=component://kwikstore/widget/FeatureForms.xml';
    return this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => resp))
  }

  createMenuItems(productFeatureCategories:any[]):NbMenuItem[]{
    let menuItems:NbMenuItem[] = [];
    productFeatureCategories.forEach((productFeatureCategory,i) => {
      if(i < 6){
        let productFeatureCategoryId = productFeatureCategory["productFeatureCategoryId"];
        let menuItem:NbMenuItem = {title:productFeatureCategory["description"]};
        menuItem.children = [
          {
            title:"Edit Feature Category",
            link:"/admin/features/feature-category/"+productFeatureCategoryId,
            icon:"edit-outline",
            data:{
              event:"edit",
              type:"EditProductFeatureCategory",
              data:{
                formData:{
                  formName:"EditProductFeatureCategory",
                  formLocation:"component://kwikstore/widget/FeatureForms.xml"
                },
                appContext:"catalog",
              "parameters":{"productFeatureCategoryId":productFeatureCategoryId}
              }
            }
          },
          {
            title:"Features in Category",
            link:"/admin/features/feature-category/"+productFeatureCategoryId+"/features",
            icon:"grid-outline",
            data:{
              event:"relate",
              type:"Category Features"
            }
          },
          {
            title:"Child Feature Categories",
            link:"/admin/features/feature-category/"+productFeatureCategoryId+"/features",
            icon:"arrow-downward-outline",
            data:{
              event:"relate",
              type:"Child Feature Categories"
            }
          },
          /* {
            title:"Parent Feature Categories",
            link:"/admin/features/feature-category/"+productFeatureCategoryId+"/features",
            icon:"grid-outline",
            data:{
              event:"relate",
              type:"Category Features"
            }
          } */
          /* {
            title:"",
            link:"",
            icon:"",
            data:{
              event:"",
              type:""
            }
          },
          {
            title:"",
            link:"",
            icon:"",
            data:{
              event:"",
              type:""
            }
          } */
  
  
        ]
        menuItems.push(menuItem)
      }
      
    })
    return menuItems;
  }

  addChildMenus(menuTag:string):void{
    this.menuService.addItems(featureMenuItems,menuTag);
    this.menuService.addItems(featureTypeMenuItems,menuTag);
    this.menuService.addItems(featureGroupsMenuItems,menuTag);
  }


}


